module.exports = __webpack_public_path__ + "static/img/btn3.98d8bf12.png";